module.exports = __webpack_public_path__ + "img/gift7-03-c1.58e6eb33.png";